export const SKILL_STATUSES = [
  "NOT_APPLICABLE",
  "PLANNED",
  "OVERDUE",
  "TRAINING_COMPLETED",
  "ASSESSED_COMPETENT"
];
